import React, { useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import omit from 'lodash/omit';
import classNames from 'classnames';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { getColumnLock, isStickySupport } from './utils';
import { ColumnAlign, ColumnLock } from './enum';
import TableCellInner from './TableCellInner';
import { groupedAggregationTree } from './AggregationTree';
const TableFooterCell = function TableFooterCell(props) {
    const { columnGroup, style, className, colSpan, right } = props;
    const { rowHeight, dataSet, prefixCls, tableStore } = useContext(TableContext);
    const { column } = columnGroup;
    const { autoFootHeight, footerRowHeight, aggregation } = tableStore;
    const { footer, footerClassName, footerStyle = {}, align, name, command, lock } = column;
    const columnLock = isStickySupport() && tableStore.overflowX && getColumnLock(lock);
    const classString = classNames(`${prefixCls}-cell`, {
        [`${prefixCls}-cell-fix-${columnLock}`]: columnLock,
        [`${prefixCls}-cell-no-transition`]: !tableStore.tableColumnResizeTransition,
    }, className, footerClassName);
    const innerClassNames = [`${prefixCls}-cell-inner`];
    const innerProps = {};
    if (!autoFootHeight) {
        const $rowHeight = footerRowHeight === undefined ? rowHeight : footerRowHeight;
        if ($rowHeight !== 'auto') {
            innerProps.style = {
                height: pxToRem($rowHeight),
            };
            innerClassNames.push(`${prefixCls}-cell-inner-row-height-fixed`);
        }
    }
    const cellStyle = {
        textAlign: align || (command ? ColumnAlign.center : tableStore.getConfig('tableColumnAlign')(column, dataSet.getField(name))),
        ...footerStyle,
        ...style,
    };
    const aggregationTree = useMemo(() => {
        if (aggregation) {
            const { column: $column, headerGroup } = columnGroup;
            if (headerGroup) {
                const { tableGroup } = columnGroup;
                if (tableGroup) {
                    const { columnProps } = tableGroup;
                    const { totalRecords } = headerGroup;
                    if (columnProps && totalRecords.length) {
                        const { children } = columnProps;
                        if (children && children.length) {
                            const renderer = ({ colGroup, style }) => {
                                return (React.createElement(TableCellInner, { record: totalRecords[0], column: colGroup.column, style: style, inAggregation: true }));
                            };
                            return groupedAggregationTree({
                                columns: children,
                                headerGroup,
                                column: { ...$column, ...columnProps },
                                renderer,
                            });
                        }
                    }
                }
            }
        }
    }, [columnGroup, aggregation]);
    if (columnLock) {
        if (columnLock === ColumnLock.left) {
            cellStyle.left = pxToRem(columnGroup.left, true);
        }
        else if (columnLock === ColumnLock.right) {
            cellStyle.right = pxToRem(colSpan && colSpan > 1 ? right : columnGroup.right + right, true);
        }
    }
    const getFooter = () => {
        switch (typeof footer) {
            case 'function': {
                const footerHookOptions = {
                    dataSet,
                    name,
                    aggregationTree,
                };
                try {
                    return footer(footerHookOptions);
                }
                catch (e) {
                    return footer(dataSet, name);
                }
            }
            case 'string':
                return React.createElement("span", null, footer);
            default:
                return footer;
        }
    };
    return (React.createElement("th", { className: classString, style: omit(cellStyle, ['width', 'height']), colSpan: colSpan, scope: "col" },
        React.createElement("div", Object.assign({}, innerProps, { className: innerClassNames.join(' ') }), getFooter())));
};
TableFooterCell.displayName = 'TableFooterCell';
export default observer(TableFooterCell);
